var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 19,
    viewBox: "0 0 10 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.55281C9.92131 9.65455 9.82635 9.79329 9.71781 9.91661C7.38705 12.568 5.06986 15.241 2.70111 17.8493C2.3538 18.2316 1.74058 18.5492 1.28745 18.4937C0.872311 18.4443 0.392049 17.9295 0.153275 17.4763C-0.153333 16.8905 0.0257473 16.2215 0.462596 15.7158C1.41498 14.6183 2.37279 13.53 3.33331 12.4416C4.17988 11.4828 5.02915 10.5271 5.91642 9.52506C5.72106 9.28767 5.56097 9.0811 5.39003 8.88687C3.79458 7.06786 2.18286 5.26736 0.600976 3.43294C-0.348694 2.3292 -0.109921 0.837006 1.09209 0.534866C1.50995 0.430042 2.15844 0.565697 2.44876 0.886333C4.99388 3.695 7.4793 6.56841 9.98372 9.42332C9.99457 9.43874 9.98915 9.47265 9.99729 9.55281L10 9.55281Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.e87f4089051a65842a72a6d033923f17.svg";
export { ForwardRef as ReactComponent };